import React from 'react';
import Reflux from 'reflux';
import AlertBarActions from 'flux/actions/AlertBarActions';
import AlertBarStore from 'flux/stores/AlertBarStore';
import classNames from 'classnames';
import {
  isInShow,
  isGlobalElementManager,
  isTeleprompter,
} from 'main/components/show/cuesheet/cuesheetViewHelper';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

/**
 * Generic alert bar that is fixed along the top of the page
 *
 */
const Managed = React.createClass({
  mixins: [Reflux.connect(AlertBarStore, 'alert')],

  displayName: 'AlertBarManaged',

  render() {
    if (!this.isVisible()) return null;

    return (
      <AlertBar {...this.state.alert.toJS()} onDismiss={this._handleClose} />
    );
  },

  _handleClose() {
    AlertBarActions.hide();
  },

  isVisible() {
    return this.state.alert ? true : false;
  },
});

const AlertBar = (props) => {
  const {
    dismissible,
    dots,
    message,
    type,
    onDismiss,
    linkText,
    linkAction,
    fixed,
    size,
    title,
    actionButton,
  } = props;

  let dismissNode = null;

  if (dismissible) {
    dismissNode = (
      <span
        onClick={() => onDismiss()}
        className="alert-bar-dismiss fa fa-close"
      ></span>
    );
  }

  let linkNode = null;
  if (linkText && linkAction) {
    linkNode = (
      <span>
        &nbsp;<a onClick={linkAction}>{linkText}</a>
      </span>
    );
  }

  if (!type) return null;

  if (title === 'disconnect' && (!isInShow() || isTeleprompter())) return null;

  let classes = classNames(
    'alert-bar',
    'alert-bar-' + type.toLowerCase(),
    { 'alert-bar-push-content-down': typeof fixed !== 'undefined' && !fixed },
    { small: size === 'small' },
  );

  const loadingDots = dots ? (
    <span className="dots">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  ) : null;

  const style = {};

  if (isGlobalElementManager() && size === 'small') style.color = 'white';

  return (
    <div className={classes}>
      <span className="inner-alert-bar" style={style}>
        <span>{message}</span>
        {loadingDots}
        {linkNode}
        {actionButton}
        {dismissNode}
      </span>
    </div>
  );
};

export { Managed };
export default AlertBar;
